import { AxiosResponse } from 'axios';
import { useMutation } from 'react-query';

import { RESET_OFFRE_CHOISIE_END_POINT } from '../../apiEndPoints';
import {
    axiosInstance,
    reactQueryOptions,
    IMutationResult,
    getDynamicHeaders
} from '../../../../api';

const putResetOffreChoisie = async (
    idDemande: number
): Promise<AxiosResponse<any>> => {
    const endPoint = RESET_OFFRE_CHOISIE_END_POINT.replace(
        /{idDemande}/g,
        String(idDemande)
    );

    const { data: response } = await axiosInstance.put(
        endPoint,
        {},
        await getDynamicHeaders()
    );

    return response;
};

export const useResetOffreChoisieApi = (): IMutationResult => {
    return useMutation(putResetOffreChoisie, {
        ...reactQueryOptions()
    });
};
